import type { ProductLogoSmallProps } from "../types";

/**
 * 小サイズのIDAndAccessロゴアイコン
 */
export function ProductLogoSmallIDAndAccess({
  size = 20,
  color = "#1874A1",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        d="M16.1737 15.9505C17.4936 14.6028 18.3276 12.8542 18.5444 10.9804C18.7612 9.10647 18.3485 7.2137 17.3713 5.60016C17.1567 5.24585 16.6956 5.13258 16.3413 5.34715C15.987 5.56173 15.8737 6.02289 16.0883 6.3772C16.893 7.706 17.2329 9.26475 17.0543 10.8079C16.8758 12.3511 16.1889 13.7911 15.102 14.901C14.0151 16.011 12.5898 16.7278 11.0507 16.9386C9.62956 17.1333 8.18588 16.8863 6.9138 16.2359L7.35579 15.4703C7.50428 15.2131 7.26769 14.9048 6.98084 14.9817L4.6994 15.593C4.52157 15.6406 4.41605 15.8234 4.46369 16.0012L5.07501 18.2827C5.15187 18.5695 5.53717 18.6203 5.68566 18.3631L6.163 17.5363C7.72409 18.3523 9.50326 18.6646 11.2543 18.4247C13.1232 18.1687 14.8539 17.2983 16.1737 15.9505Z"
        fill={color}
      />
      <path
        d="M15.5087 4.40707L13.2273 5.01838C12.9404 5.09524 12.7038 4.78692 12.8523 4.52974L13.2943 3.76418C12.0222 3.11369 10.5786 2.86675 9.15742 3.06142C7.61831 3.27225 6.19305 3.98908 5.10613 5.09901C4.0192 6.20894 3.33238 7.6489 3.15382 9.1921C2.97527 10.7353 3.31513 12.294 4.11988 13.6228C4.33446 13.9771 4.22118 14.4383 3.86688 14.6529C3.51258 14.8675 3.05141 14.7542 2.83684 14.3999C1.85964 12.7863 1.44695 10.8936 1.66377 9.01969C1.88058 7.14581 2.71458 5.39729 4.03442 4.04952C5.35425 2.70175 7.08492 1.83131 8.95385 1.5753C10.7049 1.33544 12.484 1.64769 14.0451 2.46375L14.5225 1.63698C14.6709 1.37979 15.0563 1.43052 15.1331 1.71737L15.7444 3.99882C15.7921 4.17664 15.6865 4.35942 15.5087 4.40707Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.60407 13C9.26093 13 10.6041 11.6569 10.6041 10C10.6041 8.34317 9.26093 7.00002 7.60407 7.00002C5.94722 7.00002 4.60407 8.34317 4.60407 10C4.60407 11.6569 5.94722 13 7.60407 13ZM7.60407 11C8.15636 11 8.60407 10.5523 8.60407 10C8.60407 9.44774 8.15636 9.00003 7.60407 9.00003C7.05179 9.00003 6.60407 9.44774 6.60407 10C6.60407 10.5523 7.05179 11 7.60407 11Z"
        fill={color}
      />
      <path
        d="M15.2017 8.59766C15.1392 8.53514 15.0544 8.50003 14.966 8.50003H9.9374C9.75331 8.50003 9.60407 8.64926 9.60407 8.83336V10.6667C9.60407 10.8508 9.75331 11 9.9374 11H10.966C11.0544 11 11.1392 11.0351 11.2017 11.0977L11.8684 11.7643C11.9985 11.8945 12.2096 11.8945 12.3398 11.7643L12.8684 11.2357C12.9985 11.1056 13.2096 11.1056 13.3398 11.2357L13.8684 11.7643C13.9985 11.8945 14.2096 11.8945 14.3398 11.7643L16.1184 9.98573C16.2485 9.85555 16.2485 9.6445 16.1184 9.51432L15.2017 8.59766Z"
        fill={color}
      />
    </svg>
  );
}
